// @ts-strict-ignore
import { Vector3 } from 'three';
import { TextValueVO } from '@shared/vo/meta-element.vo';

export class DimensionDescriptor {
  public startPoint: Vector3;
  public endPoint: Vector3;
  public text: TextValueVO;
  public isOuterLabel: boolean;
  public sizeLevel: number;
  public minX: number;
  public maxX: number;
  public fontSize: number;
  public fontScale: number;
  public arrowMultiplier: number;
  public pointerRequired: boolean = true;
  public index: number;
  public pointerOnRight: boolean = true;

  constructor() {
    this.sizeLevel = 0;
  }
}
